module.exports = "../images/hero-logo-v2.png?v=050305e";